var exports = {
  "k": "xae11d333--a08a6f--container",
  "M": "xae11d333--a08a6f--slide",
};

module.exports = exports;
